























































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from 'firebase/app'

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}
interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}

interface AddUserDocument {
	id: string;
	user: AddUser;
}
interface UpdateUserDocument {
	id: string;
	user: UpdateUser;
}
interface AddUser {
	name: string;
	address: string;
	phoneNumber: string;
	createdAt: any;
	updatedAt: any;
}
interface UpdateUser {
	name: string;
	address: string;
	phoneNumber: string;
	updatedAt: any;
}

interface AddProfileDocument {
	id: string;
	profile: AddProfile;
}
interface UpdateProfileDocument {
	id: string;
	profile: UpdateProfile;
}
interface AddProfile {
	displayName: string;
	photoURL: string;
	createdAt: any;
	updatedAt: any;
}
interface UpdateProfile {
	displayName: string;
	photoURL: string;
	updatedAt: any;
}

@Component
export default class FirestoreComponent extends Vue {
  @Prop()
	private msg!: string;
	private isSignin: boolean = false;
	private signinStatus = "signed out"

	private isActive = "1"
  
	private query_users_documents: Array<AddUserDocument> = new Array(0)
	private add_users_document: AddUserDocument = {id: "", user: {name: "", address: "", phoneNumber: "", createdAt: "", updatedAt: ""}};
	private update_users_document: UpdateUserDocument = {id: "", user: {name: "", address: "", phoneNumber: ""/*, createdAt: ""*/, updatedAt: ""}};
	private update_users_index = -1
	private update_users_proc = ""
	private update_users_result = ""

	private query_profiles_documents: Array<AddProfileDocument> = new Array(0)
	private add_profiles_document: AddProfileDocument = {id: "", profile: {displayName: "", photoURL: "", createdAt: "", updatedAt: ""}};
	private update_profiles_document: UpdateProfileDocument = {id: "", profile: {displayName: "", photoURL: ""/*, createdAt: ""*/, updatedAt: ""}};
	private update_profiles_index = -1
	private update_profiles_proc = ""
	private update_profiles_result = ""

	created () {
		const user = this.$auth.currentUser;
		if (user) {
			// User is signed in.
			const email = user.email
			window.console.log("created() 1.email: " + email)
			if (email == "toru.watanabe11@gmail.com") {
				this.isSignin = true
				this.signinStatus = "signed in"
			} else {
				this.isSignin = false
				this.signinStatus = "signed out"
			}
		} else {
			// No user is signed in.
			this.isSignin = false
			this.signinStatus = "signed out"
		}
		// 「users」コレクションを読む
		this.query_users()
		// 「public-profiles」コレクションを読む
		this.query_profiles()
	}

	private query_users(): void {
		window.console.log("query_users() 1.")
		const contentsRef = this.$firestore.collection('users') // ①
		contentsRef
			// 「products」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("query_users() 2.doc.id: " + doc.id)
					var data = doc.data() // ④
					window.console.log("query_users() 3.data.name: " + data.name)
					window.console.log("query_users() 4.data.address: " + data.address)
					window.console.log("query_users() 5.data.phoneNumber: " + data.phoneNumber)
					//const photoURL = "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/" + data.photoURL + "?alt=media"
					this.query_users_documents.push({id:doc.id, user: {name: data.name, address: data.address, phoneNumber: data.phoneNumber, createdAt: data.createdAt.toDate(), updatedAt: data.updatedAt.toDate()}})
			})
		})
	}

	//日付から文字列に変換する関数
	private getStringFromDate(date: Date): string {
		//var today: Date = Date()
		var year_str = date.getFullYear();
		//月だけ+1すること
		var month_str = 1 + date.getMonth();
		var day_str = date.getDate();
		var hour_str = date.getHours();
		var minute_str = date.getMinutes();
		var second_str = date.getSeconds();

		var format_str = "YYYY-MM-DD hh:mm:ss";
		format_str = format_str.replace(/YYYY/g, year_str.toString());
		format_str = format_str.replace(/MM/g, month_str.toString());
		format_str = format_str.replace(/DD/g, day_str.toString());
		format_str = format_str.replace(/hh/g, hour_str.toString());
		format_str = format_str.replace(/mm/g, minute_str.toString());
		format_str = format_str.replace(/ss/g, second_str.toString());

		return format_str;
	}

	private click_user_add(): void {
		window.console.log("click_user_add() 1.name: " + this.add_users_document.user.name)
		window.console.log("click_user_add() 2.address: " + this.add_users_document.user.address)
		window.console.log("click_user_add() 3.phoneNumber: " + this.add_users_document.user.phoneNumber)
		if (this.add_users_document.user.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.add_users_document.user.address == "") {
			alert("addressが空白です")
			return
		}
		if (this.add_users_document.user.phoneNumber == "") {
			alert("phoneNumberが空白です")
			return
		}

		var message = "id: " + this.add_users_document.id
		message += "name: " + this.add_users_document.user.name
		message += "\naddress: " + this.add_users_document.user.address
		message += "\nphoneNumber: " + this.add_users_document.user.phoneNumber
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.addUserDocument()
			//alert("登録機能は未サポートです")
		}
	}

	private addUserDocument(): void {
		window.console.log("addUserDocument() 1." + this.$watanabe)
		//this.add_document.user.createdAt = firebase.firestore.FieldValue.serverTimestamp(),
		//this.add_document.user.updatedAt = firebase.firestore.FieldValue.serverTimestamp(),
		window.console.log("addUserDocument() 2.")
		const usersRef = this.$firestore.collection('users') // ①
		usersRef.add(this.add_users_document.user) // ②
		.then((docRef: any) => {
			window.console.log("addUserDocument() 4.Document written with ID: " + docRef.id) // ③
		})
		.catch((error: any) => {
			window.console.log("addUserDocument() 5.Error adding document: " + error)  // ④
		})
	}

	private click_user_update(index: number): void {
		window.console.log("click_user_update() 1.index: " + index)
		window.console.log("click_user_update() 2.name: " + this.query_users_documents[index].user.name)
		this.update_users_index = index
		this.update_users_document.id = "********"//this.query_users_documents[index].id
		this.update_users_document.user.name = this.query_users_documents[index].user.name
		this.update_users_document.user.address = this.query_users_documents[index].user.address
		this.update_users_document.user.phoneNumber = this.query_users_documents[index].user.phoneNumber
	}

	private click_user_update2(): void {
		window.console.log("click_update2() 1.name: " + this.update_users_document.user.name)
		window.console.log("click_update2() 2.address: " + this.update_users_document.user.address)
		window.console.log("click_update2() 3.phoneNumber: " + this.update_users_document.user.phoneNumber)
		if (this.update_users_document.id == "") {
			alert("IDが空白です")
			return
		}
		if (this.update_users_document.user.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.update_users_document.user.address == "") {
			alert("addressが空白です")
			return
		}
		if (this.update_users_document.user.phoneNumber == "") {
			alert("phoneNumberが空白です")
			return
		}

		var message = "id: " + this.update_users_document.id
		message += "name: " + this.update_users_document.user.name
		message += "\naddress: " + this.update_users_document.user.address
		message += "\nphoneNumber: " + this.update_users_document.user.phoneNumber
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.updateUserDocument()
			//alert("登録機能は未サポートです")
		}
	}

	private updateUserDocument(): void {
		window.console.log("updateDocument() 1.update_users_index; " + this.update_users_index)
		if (this.update_users_index < 0) {
			window.console.log("updateDocument() 2.更新できません。")
			this.update_users_proc = "更新できません。"
			return
		}
		//this.update_document.user.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
		const documentsRef = this.$firestore.collection('users')
		documentsRef.doc(this.update_users_document.id).update(this.update_users_document.user)
		.then(() => {
			const message = "Document updated with ID: " + this.update_users_document.id
			this.update_users_result = message
			window.console.log("click_update() 4." + message)
		})
		.catch((error: any) => {
			window.console.log("click_update() 5.Error adding document: " + error)
		})
		this.update_users_proc = ""
		this.update_users_index = -1
	}

	private query_profiles(): void {
		window.console.log("query_public-profiles() 1.update_profiles_index; " + this.update_profiles_index)
		const contentsRef = this.$firestore.collection('public-profiles') // ①
		contentsRef
			// 「public-profiles」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("query_profiles() 2.doc.id: " + doc.id)
					var data = doc.data() // ④
					window.console.log("query_profiles() 3.data.displayName: " + data.displayName)
					window.console.log("query_profiles() 4.data.photoURL: " + data.photoURL)
					const photoURL = "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/" + data.photoURL + "?alt=media"
					this.query_profiles_documents.push({id:doc.id, profile: {displayName: data.displayName, photoURL: photoURL, createdAt: data.createdAt.toDate(), updatedAt: data.updatedAt.toDate()}})
			})
		})
	}

	private click_profile_update(index: number): void {
		window.console.log("click_profile_update() 1.index: " + index)
		window.console.log("click_profile_update() 2.displayName: " + this.query_profiles_documents[index].profile.displayName)
		this.update_profiles_index = index
		this.update_profiles_document.id = "********"//this.query_profiles_documents[index].id
		this.update_profiles_document.profile.displayName = this.query_profiles_documents[index].profile.displayName
		this.update_profiles_document.profile.photoURL = this.query_profiles_documents[index].profile.photoURL
	}
	
  private pre1 = `
	public queryProc(id: string) {
		window.console.log("queryProc() 1.")
		const postsRef = this.$firestore.collection('posts')  // ①
		const post1 = postsRef.doc(id).get().then((doc: any) => { // ②
			if (doc.exists) {
				const post:Post = doc.data() // ③
				this.uid = post.uid
				this.title = post.title
				this.content = post.content
				this.createdAt = post.createdAt
				this.tags = post.tags
				this.image = post.image
			
				window.console.log("queryProc() 2." + post.title)
				return doc.data() as Post; // キャスト必要
			} else {
				window.console.log("queryProc() 3.No Document")
			}
		})
		window.console.log("queryProc() 4." + this.$watanabe)
	}`
  private pre2 = `
	var posts: Array<Post> = []
	
	public queryProc2() {
		window.console.log("queryProc2() 1.")
		const postsRef = this.$firestore.collection('posts') // ①
		postsRef.get().then((snapShot: any) => { // ②
			snapShot.forEach ((doc: any) => { // ③
				var data = doc.data() // ④
				var post: Post = {uid:data.uid, title:data.title, content:data.content, createdAt:data.createdAt, tags:data.tags, image:data.image}
				this.posts.push(post)
				this.firstPost()
				window.console.log("queryProc2() 2.posts: " + this.posts)
			})
		})
		window.console.log("queryProc2() 3." + this.$watanabe)
	}
	
	public firstPost() {
		this.postIndex = 0
		var post = this.posts[this.postIndex]
		this.uid = post.uid
		this.title = post.title
		this.content = post.content
		this.createdAt = post.createdAt
		this.tags = post.tags
		this.image = post.image
	}`
  private pre3 = `
	public addDocument() {
		window.console.log("addDocument() 1.")
		var post1: Post = {
			uid:"0001",
			title:"ダンスの練習",
			content:"トークAでダンスの練習を始めましょう",
			createdAt:"2020-11-6",
			tags:["Dance"],
			image:"../assets/firestore_1.png"
		}
		const postsRef = this.$firestore.collection('posts') // ①
		postsRef.add(post1) // ②
		.then((docRef: any) => {
			window.console.log("addDocument() 2.Document written with ID: " + docRef.id) // ③
		})
		.catch((error: any) => {
			window.console.log("addDocument() 3.Error adding document: " + error)  // ④
		})
	}`
  private pre4 = `
	import firebase from 'firebase/app'
	import 'firebase/firestore'
	import 'firebase/auth'
	import config from './config'

	export default {
  	install(Vue: any, options: any) {
    	const firebaseApp = firebase.initializeApp(config)

	    // instance propertyの登録
	    Vue.prototype.$firestore = firebaseApp.firestore()
	    Vue.prototype.$auth = firebaseApp.auth()
	    Vue.prototype.$watanabe = 'watanabe'
	    window.console.log("index.ts install() 1.");
	    //window.console.log("index.ts install() 2." + this.$watanabe);

	  },
	};`
  private pre5 = `
	import Vue from 'vue'
	import App from './App.vue'
	import './registerServiceWorker'
	import router from './router'
	import store from './store'

	// ここから追加
	import firebase from './firebase' // 追記
	Vue.use(firebase) //追記
	window.console.log("main.ts 1.");
	// ここまで追加

	Vue.config.productionTip = false

	new Vue({
	  router,
	  store,
	  render: h => h(App)
	}).$mount('#app')`
  private pre6 = `
	import Vue from 'vue'
	import firebase from 'firebase/app'

	declare module 'vue/types/vue' {
	  interface Vue {
	    $auth: firebase.auth.Auth,
	    $firestore: firebase.firestore.Firestore
	    $watanabe: string,
	  }
	}`

  private contents1: Description = {
  	id: "1",
  	title: "firestoreの概要",
  	descriptions: [
  	 {id: "1",
  	  title: "「firestore」は、新しい時代の「Webサーバ」です。",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"従来の「Webサーバ」は、「HTTP/1」技術をベースにしていました。",
  	  	"新しい「Webサーバ」である「firestore」は、「HTTP/2」技術をベースにしています。",
  	  	"「firestore」は、「HTTP/2」をサポートする「gRPC」を使用しています。",
  	  	"RPCとは「Remote Procedure Call」の略ですが、従来の「Webサーバ」と「Webブラウザ」の通信方式である 「HTTP/1」に比べると遥かに高度な処理が可能になっています。",
  	  	"「HTTP/2」をサポートする「gRPC」の機能の中で、最も高度な機能は「サーバPUSH通信機能」です。",
  	  	"「firestore」は、「gRPC(HTTP/2)」の「サーバPUSH通信機能」を使用して、「Realtime Listener」と呼ばれる機能を提供しています。",
  	  	"「Realtime Listener」機能は、複数のクライアント（端末）が同一のデータを参照し、 その最新状態を取得し続ける形にすることで、ユーザ間のリアルタイムなデータ共有が可能になります。",
  	    ],
  	  pres: [],
  	 }, // end of id=1
	 {id: "2",
  	  title: "「HTTP/2」をサポートする「gRPC」の概要",
  	  images: [
  	    { 
  	      //src: require("../assets/firestore_2.png"),
  		  src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/firestore_2.png?alt=media",
  	      comment: "図1 1TCPコネクション内に複数ストリームが存在するイメージ",
  	    },
  	    { 
  	      //src: require("../assets/firestore_3.png"),
  		  src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/firestore_3.png?alt=media",
  	      comment: "図2 コネクション単位のイメージ",
  	    },
  	  ],
  	  items: [
  	  	"HTTP/2 では、有効期間が長いリアルタイム通信ストリームの基盤が提供されます。",
  	  	"gRPC では、HTTP/2 を介したストリーミングが最高レベルでサポートされています。",
  	  	"gRPC サービスでは、ストリーミングのすべての組み合わせがサポートされます。",
  	  	" ・Unary (ストリーミングなし)",
  	  	" ・サーバーからクライアントへのストリーミング",
  	  	" ・クライアントからサーバーへのストリーミング",
  	  	" ・双方向ストリーミング",
  	  	"HTTP/2では一つにTCPコネクションに内において複数のストリームというデータ(フレーム)の送受信シーケンスをつくることができるようになりました。",
  	  	"また、HTTP/1.1まではヘッダー部、ボティー部は改行で分割されているだけで１つの送信・受信のデータ単位でした。",
  	  	"(ヘッダー、ボティを一括して送受信)",
  	  	"HTTP/2ではフレームというものをデータ最小単位として、ヘッダーフレーム、データフレームと独立して送受信をできるようになりました。",
  	  	"これらの機能を駆使してより柔軟な送受信に対応可能になりました。",
  	  	" ・ストリームの多重化",
  	  	" ・ストリームの優先度",
  	  	" ・フレーム",
  	  	" ・ヘッダー圧縮",
  	  	" ・フロー制御",
  	  	"1TCPコネクション内に複数ストリームが存在するイメージを図1に示します。",
  	  	"コネクション単位で見ると図2のような感じになります。",
  	    ],
	  pres: [],
  	 }, // end of id=2
	 {id: "3",
  	  title: "「firestore」で、ドキュメントのIDを指定してドキュメントを読む",
  	  images: [],
  	  items: [
  	  	"コレクションのレファレンスを得る。①",
  	  	"ドキュメントのIDを指定してドキュメントを得る。②",
  	  	"実際のデータはdata()の中にある。③",
  	  	"TypeScriptのプログラミング例を以下に示す。",
  	    ],
	  pres: [{src: this.pre1, comment: "プログラミング例1: ドキュメントのIDを指定してドキュメントを読む"}],
  	 }, // end of id=3
	 {id: "4",
  	  title: "「firestore」で、指定したコレクションの全ドキュメントを読む",
  	  images: [],
  	  items: [
  	  	"コレクションのレファレンスを得る。①",
  	  	"コレクション内の全てのドキュメントを得る。②",
  	  	"全てのドキュメントをスキャンする。③",
  	  	"実際のデータはdata()の中にある。④",
  	  	"TypeScriptのプログラミング例を以下に示す。",
  	    ],
	  pres: [{src: this.pre2, comment: "プログラミング例2: 指定したコレクションの全ドキュメントを読む"}],
  	 }, // end of id=4
	 {id: "5",
  	  title: "「firestore」で、指定したコレクションにドキュメントを追加する",
  	  images: [],
  	  items: [
  	  	"コレクションのレファレンスを得る。①",
  	  	"コレクションにドキュメントを追加する。②",
  	  	"追加したドキュメントのIDを得る。③",
  	  	"エラーが起きた時、errorコードを得る。④",
  	  	"TypeScriptのプログラミング例を以下に示す。",
  	    ],
	  pres: [{src: this.pre3, comment: "プログラミング例3: 指定したコレクションにドキュメントを追加する"}],
  	 }, // end of id=5
	 {id: "6",
  	  title: "Firebase/FirestoreをVue.jsに組み込む場合の独自プラグインの作成",
  	  images: [],
  	  items: [
  	  	"firebaseをvueに組み込む際、component内で触りやすくするために独自プラグインを実装し使用するとちょっとだけ楽になります。",
  	  	"具体的には以下のように記述することで、どのcomponentでも「this.auth.・・・」、「this.auth.・・・」、 「this.firestore.・・・」みたいな形でアクセスすることができ、importを毎度行わなくてよくなります。",
  	  	"「/src/firebase/index.ts」には、プログラミング例4を記述します。",
  	  	"「/src/firebase/config.ts」には、プログラミング例5を記述します。「****」の部分は「firebase」コンソールから入手します。",
  	  	"「/src/main.ts」には、プログラミング例6を記述します。",
  	    ],
	  pres: [
	   {src: this.pre4, comment: "プログラミング例4: Firebase/FirestoreをVue.jsに組み込む場合の独自プラグインの作成"},
	   {src: this.pre5, comment: "プログラミング例5: 「/src/firebase/config.ts」の記述"},
	   {src: this.pre6, comment: "プログラミング例6: 「/src/main.ts」の記述"},
	  ],
  	 }, // end of id=6
  	]
  }
  private contents2: Description = {
  	id: "2",
  	title: "データモデリング",
  	descriptions: [
  	 {id: "1",
  	  title: "ドキュメント設計の原則",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "Firestoreでの1:1リレーション",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "Firestoreでの1:nリレーション",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "コマンドクエリ責務分離",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	]
  }
  private contents3: Description = {
  	id: "3",
  	title: "ユーザ管理",
  	descriptions: [
  	 {id: "1",
  	  title: "ユーザ管理機能の概要",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"会員情報と公開プロフィールをAuthenticationアカウントに関連づけて管理",
  	  	"会員情報の変更履歴を保持",
  	  	"Twitter連携によるログイン",
  	  	"アカウント凍結機能",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "サインアップ",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"サインアップでは、会員のアカウントの作成を行います。",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "会員情報の更新",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "ユーザの退会処理",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4

  	]
  }
  private contents4: Description = {
  	id: "4",
  	title: "通販サイト構築例",
  	descriptions: [
  	 {id: "1",
  	  title: "アプリケーション要件",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "買い物かご",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "商品購入",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "レビュー機能",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	]
  }

} // end of export

